// extracted by mini-css-extract-plugin
module.exports = {"backbutton_wrapper":"BackButton_backbutton_wrapper__1vm2l","button_text":"BackButton_button_text__3h4g2"};